<template>
    <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 20.747 24.237">
        <g id="information" transform="translate(-61 -3)">
            <path id="Path_70136" data-name="Path 70136"
                  d="M331.8,14.705h5.118L331,8.789v5.118A.8.8,0,0,0,331.8,14.705Z"
                  transform="translate(-255.637 -5.321)" fill="#fff"/>
            <path id="Path_70137" data-name="Path 70137"
                  d="M63.394,27.237H79.353a2.4,2.4,0,0,0,2.394-2.394V10.98H76.161a2.4,2.4,0,0,1-2.394-2.394V3H63.394A2.4,2.4,0,0,0,61,5.394V24.843A2.4,2.4,0,0,0,63.394,27.237Zm4.788-14.417h7.98a.8.8,0,1,1,0,1.6h-7.98a.8.8,0,1,1,0-1.6Zm0,3.192h7.98a.8.8,0,1,1,0,1.6h-7.98a.8.8,0,1,1,0-1.6Zm0,3.192h7.98a.8.8,0,1,1,0,1.6h-7.98a.8.8,0,1,1,0-1.6ZM64.99,12.821a.8.8,0,1,1-.8.8A.8.8,0,0,1,64.99,12.821Zm0,3.192a.8.8,0,1,1-.8.8A.8.8,0,0,1,64.99,16.012Zm0,3.192a.8.8,0,1,1-.8.8A.8.8,0,0,1,64.99,19.2Z"
                  fill="#fff"/>
        </g>
    </svg>
</template>

<script>
    export default {
        name: "IInfo",
        props: {
            width: {
                type: String,
                default: '1.5em'
            },
            height: {
                type: String,
                default: '1.5em'
            }
        }
    }
</script>

<style scoped>

</style>
